// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + ({"933":"monitoring","943":"usecenter","970":"mgtcenter"}[chunkId] || chunkId) + "_" + {"697":"ac1f8322","933":"37b85ffe","943":"c1672f2b","970":"4d158700"}[chunkId] + ".css";
};